module.exports = __webpack_public_path__ + "img/bootstrap-icons.12e872fb.svg";